module.exports = __webpack_public_path__ + "static/media/eZpay_logo.ac451b53.png";